import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import {
  WHITE,
  PINK_BACKGROUND,
  AQUA_BACKGROUND,
  YELLOW_BACKGROUND,
  PURPLE_BACKGROUND,
  GREEN_BACKGROUND
} from '../../../constants/colors';
/**
 * Gets the right combination for the color
 * @param {string} color color to get gradiend
 * @returns {string} color en rgba
 */
export const getGradientColor = (color) => {
  switch (color) {
    case 'pink':
      return PINK_BACKGROUND;
    case 'aqua':
      return AQUA_BACKGROUND;
    case 'purple':
      return PURPLE_BACKGROUND;
    case 'yellow':
      return YELLOW_BACKGROUND;
    case 'green':
    default:
      return GREEN_BACKGROUND;
  }
};

export default {
  more: css`
  display:block;
  text-align:right;
  margin-bottom: 0px;
  & img{
    min-width:16px;
  }
  ${media.sm`
    & img{
    min-width:20px;
    width:20px;
  }
    margin-bottom: 30px;
  `};
  `,
  abstract: css`
    color: ${WHITE};
    font-size: ${rem('14px')};
    margin-bottom: 30px;
    display:none;
    ${media.sm`
         overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    word-wrap:break-word;
    line-height:22px;
    max-height:5.4rem;
    `};
  `,
  container: css`
    position: relative;
    overflow: hidden;
    width: auto;
    height: auto;
    min-height: 230px;
    margin-bottom: 0px;
    background-size: cover;
    ${media.sm`
      margin-bottom: 10px;
      border-radius: 12px;
    `};
    ${media.md`
      margin-left:0;
      margin-right:0;
      margin-bottom: 45px;
    `};
  `,
  title: css`
    color: ${WHITE};
    font-size: ${rem('24px')};
    line-height: ${rem('26px')};
    white-space: normal;
    margin-bottom: 15px;
    ${media.md`
      font-size: ${rem('26px')};
      line-height: ${rem('29px')};
      margin-bottom: 25px;
    `};
    position: relative;
    z-index: 5;
  `,
  innerWrapper: css`
    align-self:flex-end;
    color: ${WHITE};
    position: relative;
    z-index: 5;
    margin-left: 10px;
    margin-right: 10px;
    ${media.sm`
      margin-left: 30px;
      margin-right: 30px;
    `};

  `,
  mainExperience: css`
    min-height: 208px;
    display:flex;
    ${media.sm`
      min-height: 290px;
    `};
    ${media.md`
      min-height: 460px;
    `};
  `,
  secondaryExperience: css`
    min-height: 208px;
    display:flex;
    ${media.sm`
      min-height: 290px;
    `};
    ${media.md`
      min-height: 400px;
    `};
  `,
  gradientLayer: ({ gradientColor }) => css`
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: ${getGradientColor(gradientColor)};
    ${media.sm`
      width: 100%;
    `}
  `
};
